import axios from "axios";
import * as XLSX from "xlsx";
import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../../config";

const DetailResourceCompOpenData = ({ formatDate }) => {
    const { id, id_resource } = useParams();
    const [dataDetail, setDataDetail] = useState(null);
    const [dataDetail2, setDataDetail2] = useState([]);
    const [specificResource, setSpecificResource] = useState(null);
    const [loading, setLoading] = useState(true);
    const [excelData, setExcelData] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            try {
                const response = await axios.get(global.config.host + `/api/3/action/package_show?id=${id}`);
                setDataDetail(response.data.result);
                setDataDetail2(response.data.result.resources);
            } catch (error) {
                console.error('Error fetching data detail', error);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [id]);

    useEffect(() => {
        if (dataDetail2.length > 0 && id_resource) {
            const resource = dataDetail2.find(resource => resource.id === id_resource);
            setSpecificResource(resource);
        }
    }, [dataDetail2, id_resource]);

    useEffect(() => {
        const fetchExcelData = async () => {
            if (specificResource && specificResource.format.toLowerCase() === "xlsx") {
                try {
                    const response = await axios.get(specificResource.url, {
                        responseType: "arraybuffer",
                    });

                    const workbook = XLSX.read(new Uint8Array(response.data), { type: "array" });
                    const sheetName = workbook.SheetNames[0];
                    const sheet = workbook.Sheets[sheetName];
                    const jsonData = XLSX.utils.sheet_to_json(sheet);

                    setExcelData(jsonData);
                } catch (error) {
                    console.error("Error fetching Excel data", error);
                }
            }
        };

        fetchExcelData();
    }, [specificResource]);

    const bytesToMB = (bytes) => {
        return (bytes / (1024 * 1024)).toFixed(2); // 1 MB = 1024 KB = 1024 * 1024 bytes
    };

    return (
        <section className="d-flex align-items-center" style={{ marginTop: '60px' }}>
            <div className="container" data-aos="fade-in">
                <div className="row content" data-aos="fade-in">
                    <Link to={`/open_data/kumpulan_data/${id}`} className="breadcrumb"><i className="bx bx-arrow-back"></i> Kembali</Link>
                </div>
                {
                    loading ? (
                        <div className="col-md-12 text-center" data-aos="fade-in">
                            <h4>Loading Data...</h4>
                        </div>
                    ) :
                        (
                            !specificResource ? (
                                <div className="col-lg-12 box-no-data"> No Data Found</div>
                            ) : (

                                <div className="row content" >
                                    <div className="col-md-12 m-b-20">
                                        <p className="author">
                                            <i className="bx bx-time"></i> {specificResource.last_modified ? formatDate(specificResource.last_modified) : '-'}
                                        </p>
                                        <h4 className="m-b-10 font-weight-600" >
                                            {specificResource.name ? specificResource.name : '-'}
                                            <a href={specificResource.url} target="_blank" title={specificResource.url} className="btn-default m-l-10"><i className="bx bx-download"></i> Download</a>
                                        </h4>
                                    </div>
                                    <div className="col-md-12">
                                        <div className="box-additional">
                                            <div className="header-additional">
                                                <i className="bx bx-data"></i> Data and Resources Review
                                            </div>
                                            <div className="p-10 box-additional-body">
                                                {/* Tampilkan Excel Data jika format xlsx */}
                                                {specificResource.format.toLowerCase() === "xlsx" && excelData.length > 0 && (
                                                    <div className="table-responsive">
                                                        <table className="table table-striped table-bordered">
                                                            <thead className="thead-dark">
                                                                <tr>
                                                                    {Object.keys(excelData[0]).map((key, index) => (
                                                                        <th key={index}>{key}</th>
                                                                    ))}
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {excelData.map((row, rowIndex) => (
                                                                    <tr key={rowIndex}>
                                                                        {Object.values(row).map((cell, cellIndex) => (
                                                                            <td key={cellIndex}>{cell}</td>
                                                                        ))}
                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                )}

                                                {/* Tampilkan PDF jika format pdf */}
                                                {specificResource.format.toLowerCase() === "pdf" && (
                                                    <div className="pdf-viewer mt-3">
                                                        <object
                                                            data={specificResource.url}
                                                            type="application/pdf"
                                                            width="100%"
                                                            height="600px"
                                                        >
                                                            <iframe
                                                                src={specificResource.url}
                                                                title="PDF Preview"
                                                                width="100%"
                                                                height="600px"
                                                            >
                                                                This browser does not support PDFs.
                                                            </iframe>
                                                        </object>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                        <div className="box-additional">
                                            <div className="header-additional">
                                                <i className="bx bx-info-circle"></i> Additional Information
                                            </div>
                                            <div>
                                                <table className="table table-striped-columns m-b-0">
                                                    <tbody>
                                                        <tr>
                                                            <td className="font-weight-100">Created</td>
                                                            <td>{
                                                                specificResource.created != null ? formatDate(specificResource.created) : '-'
                                                            }</td>
                                                        </tr>
                                                        <tr>
                                                            <td className="font-weight-100">Data last updated</td>
                                                            <td>{
                                                                specificResource.last_modified != null ? formatDate(specificResource.last_modified) : '-'
                                                            }</td>
                                                        </tr>
                                                        <tr>
                                                            <td className="font-weight-100">Metadata last updated</td>
                                                            <td>{
                                                                specificResource.metadata_modified != null ? formatDate(specificResource.metadata_modified) : '-'
                                                            }</td>
                                                        </tr>
                                                        <tr>
                                                            <td className="font-weight-100">Format</td>
                                                            <td>{
                                                                specificResource.format != null ? specificResource.format : '-'
                                                            }</td>
                                                        </tr>
                                                        <tr>
                                                            <td className="font-weight-100">License</td>
                                                            <td>{
                                                                (dataDetail.license_id != null) ?
                                                                    (
                                                                        <a href={dataDetail.license_url} target="_blank">
                                                                            {dataDetail.license_title}
                                                                        </a>

                                                                    ) : '-'
                                                            }</td>
                                                        </tr>
                                                        <tr>
                                                            <td className="font-weight-100">Mimetype</td>
                                                            <td>{
                                                                specificResource.mimetype != null ? specificResource.mimetype : '-'
                                                            }</td>
                                                        </tr>
                                                        <tr>
                                                            <td className="font-weight-100">On same domain</td>
                                                            <td>{
                                                                dataDetail.isopen != null ? (
                                                                    dataDetail.isopen === true ? <label className="label bg-green font-weight-700">True</label> : <label className="label bg-danger font-weight-700">False</label>
                                                                ) : '-'

                                                            }</td>
                                                        </tr>
                                                        <tr>
                                                            <td className="font-weight-100">Position</td>
                                                            <td>{
                                                                specificResource.position != null ? specificResource.position : '-'
                                                            }</td>
                                                        </tr>
                                                        <tr>
                                                            <td className="font-weight-100">Size</td>
                                                            <td>{
                                                                specificResource.size != null ? `${bytesToMB(specificResource.size)} MB` : '-'
                                                            }</td>
                                                        </tr>
                                                        <tr>
                                                            <td className="font-weight-100">State</td>
                                                            <td>{
                                                                specificResource.state != null ? (
                                                                    specificResource.state === 'active' ? <label className="label bg-green font-weight-700">{specificResource.state}</label> : <label className="label bg-danger font-weight-700">{specificResource.state}</label>
                                                                ) : '-'
                                                            }</td>
                                                        </tr>
                                                        <tr>
                                                            <td className="font-weight-100">Url type</td>
                                                            <td>{
                                                                specificResource.url_type != null ? specificResource.url_type : '-'
                                                            }</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )
                        )
                }
            </div>
        </section>
    )
}

export default DetailResourceCompOpenData;